import type { DBSchema, IDBPDatabase } from "idb";
import { openDB } from "idb";

export interface LocalRecordingStreamPartData {
  arrayBuffer: ArrayBuffer;
  partId: string;
}

export interface LocalRecordingStreamPartMetadata {
  partId: string;
  byteLength: number;
  uploaded: boolean;
  streamId: string;
}

export interface LocalRecordingStream {
  id: string;
  localTimeOffset: number;
  recordingStartTime: number;
  recordingStopTime: number;
  sessionId: string;
  storyId: string;
  streamId: string;
  type: string;
  userId: string;
  uploadId: string;
  uploadKey: string;
  uploadToken: string;
  partIds: string[];
}

export interface LocalRecordingUpdateTimes {
  streamId: string;
  updateTime: number;
}

interface TheirStorySchema extends DBSchema {
  streams: {
    key: string;
    value: LocalRecordingStream;
  };
  streamPartMeta: {
    key: string;
    value: LocalRecordingStreamPartMetadata;
  };
  streamPartData: {
    key: string;
    value: LocalRecordingStreamPartData;
  };
  streamUpdateTimes: {
    key: string;
    value: LocalRecordingUpdateTimes;
  };
}

export const recordingsDB = (): Promise<IDBPDatabase<TheirStorySchema>> => {
  const { location: { hostname = "" } = {} } = window;
  const dbName =
    hostname === "staging.theirstory.io"
      ? "theirstory-staging"
      : hostname === "localhost"
      ? "theirstory-localhost"
      : "theirstory";

  if (!("indexedDB" in window)) {
    return null;
  }
  return openDB<TheirStorySchema>(`${dbName}-new`, 4, {
    upgrade(db) {
      for (const [table, key] of [
        ["streams", "id"],
        ["streamPartMeta", "partId"],
        ["streamPartData", "partId"],
        ["streamUpdateTimes", "streamId"],
      ] as any) {
        if (!db.objectStoreNames.contains(table)) {
          db.createObjectStore(table, {
            keyPath: key,
          });
        }
      }
    },
  });
};

export const arrayBufferToBlob = (buffer: ArrayBuffer, type: string): Blob => new Blob([buffer], { type: type });
